<template>
  <div id="app">
    <!-- <img src="./assets/logo.png">
    <ul>
      <li><router-link  to='/Ahmet'>Go to Ahmet</router-link></li>
      <li><router-link  to='/'>Go to Root</router-link></li>
      <li><router-link  to='/ChartDev'>Go to ChartDev</router-link></li>
      <li><a href="/index_f7.html" target="_blank">Go to index_f7</a></li>
    </ul> -->
    <router-view></router-view>
  </div>
</template>

<script>
// import 'reset-css/reset.css'

export default {
  name: 'app'
}
</script>

<style>
/*#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/
</style>



// WEBPACK FOOTER //
// src/App.vue